import { createCrudContext } from "./_lib/createCrudContext";

const { Provider, useValue } = createCrudContext({
  name: "currency",
  client: "service",
  listPath: "country/currency",
  adminPath: "currency",
  legacy: {
    data: "currency",
    count: "count",
    fetch: "fetchCurrencies",
    create: "createOneCurrency",
    update: "updateCurrency",
    remove: "deleteCurrency",
    updateState: "updateCurrencyState",
  },
});

export const CurrencyProvider = Provider;
export const useCurrencyContext = useValue;
